<div class="question-response-container" [ngClass]="{'is-number': isNumber}">
  <textarea 
    *ngIf="!readOnly && !isNumber"
    [formControl]="questionControl" name="" id="">
  </textarea>

  <input type="number" *ngIf="!readOnly && isNumber"
  [formControl]="questionControl">

  <div class="textarea p-sm"  *ngIf="readOnly">
    {{ questionControl?.value }}
  </div>
</div>